<template>
  <form
    :id="id"
    :action="action"
    :method="method"
    :novalidate="novalidate"
    :enctype="enctype"
    :target="target"
  >
    <slot />
  </form>
</template>

<script>
export default {
  name: "Form",
  props: {
    id: { type: String, required: true },
    action: { type: String, default: "" },
    method: { type: String, default: "" },
    novalidate: { type: String, default: "false" },
    enctype: { type: String, default: "application/x-www-form-urlencoded" },
    target: { type: String, default: "_self" },
  },
};
</script>
